import { Button, Image, Space, Table } from "antd";
import { getMediaUrl } from 'config/env';
import Loading from 'layouts/Loading/Loading';
import Axios from 'middleware/axiosInstance';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function ImageGalleries() {
  const navigate = useNavigate();

  const [allImageGalleries, setAllImageGalleries] = useState(null)
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});

  const getAllImageGalleries = () => {
    Axios.get("/image-gallery")
      .then((res) => {
        setAllImageGalleries(res.data)
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    getAllImageGalleries()
  }, []);

  const clearFilters = () => {
    setFilteredInfo({});
  };

  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const deleteDoc = (imageGallery) => {
    if (window.confirm(`آیا تصویر "${imageGallery.title_fa}" حذف گردد؟`)) {
      deleteDocHandler(imageGallery);
    }
  };

  const deleteDocHandler = (imageGallery) => {
    Axios.delete(`image-gallery/${imageGallery.id}`)
      .then((res) => {
        if (res.status === 204) {
          console.log(res);
        }
        getAllImageGalleries()
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
      });
  };

  const goToAddPage = () => {
    navigate("/image-galleries/add")
  }

  const goToSortingPage = () => {
    navigate("/image-galleries/sorting")
  }

  const columns = [
    {
      title: "تصویر",
      dataIndex: "image",
      key: "image",
      width: 100,
      render: (image, record) => (
        image ? (
          <Image
            width={60}
            height={60}
            src={getMediaUrl(image)}
            alt={record.title_fa}
            style={{ objectFit: 'cover', borderRadius: '4px' }}
            preview={false}
          />
        ) : (
          <span>-</span>
        )
      ),
    },
    {
      title: "عنوان فارسی",
      dataIndex: "title_fa",
      key: "title_fa",
      sorter: (a, b) =>
        a.title_fa > b.title_fa ? 1 : b.title_fa > a.title_fa ? -1 : 0,
      sortOrder: sortedInfo.columnKey === "title_fa" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "عنوان انگلیسی",
      dataIndex: "title_en",
      key: "title_en",
      sorter: (a, b) =>
        a.title_en > b.title_en ? 1 : b.title_en > a.title_en ? -1 : 0,
      sortOrder: sortedInfo.columnKey === "title_en" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "عنوان عربی",
      dataIndex: "title_ar",
      key: "title_ar",
      ellipsis: true,
    },
    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      render: (a, imageGallery) => (
        <Space size="small">
          <Link
            to={`/image-galleries/edit/${imageGallery.id}`}
            className="btn btn-primary btn-sm"
          >ویرایش</Link>
          <button
            onClick={() => deleteDoc(imageGallery)}
            className="btn btn-danger btn-sm"
          >حذف</button>
        </Space>
      ),
    },
  ];

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <Space
          style={{
            marginBottom: 16,
          }}
        >
          <Button onClick={goToAddPage}>اضافه کردن</Button>
          <Button onClick={clearFilters}>حذف فیلترها</Button>
          <Button onClick={clearAll}>حذف فیلتر و مرتب ها</Button>
          <Button 
            onClick={goToSortingPage}
          >
            مرتب‌سازی و ترتیب‌بندی
          </Button>
        </Space>
        <div>
          {allImageGalleries ?
            allImageGalleries[0] ?
              <Table
                pagination={false}
                columns={columns}
                dataSource={allImageGalleries}
                rowKey="id"
                onChange={handleChange}
              />
              : <h2>محتوایی نیست</h2> : <Loading />}
        </div>
      </div>
    </div>
  );
}

export default ImageGalleries;

